import React from 'react';
import Areas from '../../Configuration/Areas';

/** Misma pantalla de áreas de empresa, accesible desde Activos → Configuración. */
const ActivosAreas = () => <Areas breadcrumbMode="activos" />;

export default ActivosAreas;
